<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="modalWidth"
    top="15vh"
    :modal-append-to-body="false"
    :before-close="handleClose"
    custom-class="custom-dialog-class"
  >
    <div class="font-normal -mt-6">
      <div class="flex justify-center"><circle-icon /></div>
      <div
        style="word-break: normal"
        class="text-xl mt-4 font-bold w-4/5 md:w-2/4 lg:w-3/5 mx-auto text-center text-root-2 flex justify-center"
      >
        Transaction in progress
      </div>
      <div
        class="text-xs md:text-sm text-center text-root-4 md:w-9/12 lg:w-11/12 mx-auto"
      >
        <p style="word-break: normal" class="my-3">
          {{
            transactionIsFromHoldings
              ? `Your ${
                  initiatedTransactionAmountDetails.currency
                } holdings account has been debited ${parseMoneyAll(
                  initiatedTransactionAmountDetails.amount,
                  initiatedTransactionAmountDetails.currency
                )}`
              : ''
          }}
        </p>
        <p style="word-break: normal">{{ transactionProcessingMessage }}</p>
        <p
          @click="goToTerminal"
          class="cursor-pointer mt-3 text-primary underline text-xs"
        >
          Do another transfer
        </p>
      </div>

      <div class="mx-4 border-none my-4">
        <div class="flex flex-col items-center justify-center">
          <div
            style="word-break: normal"
            @click="saveBeneficiary"
            class="flex items-center justify-center cursor-pointer mr-3 p-3 w-1/2 text-primary"
            v-if="!usedBeneficiary"
          >
            <div class="flex items-center gap-x-3 mb-2">
              <user-plus-icon v-if="!isLoading" :color="$primaryColor" />
              <p>
                {{ !isLoading ? 'Save Beneficiary' : 'Saving Beneficiary....' }}
              </p>
            </div>
          </div>
          <el-button
            class="bg-primary py-4 text-white rounded-md w-full"
            @click="doneHandler"
            >Done</el-button
          >
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
import terminal from '@/mixins/terminal.js'
import { ParseMoneyAll } from '@/utils/helpers'
import { TRANSACTION_PROCESSING_MESSAGE } from '@/utils/constants'
export default {
  mixins: [terminal],
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      breakpoints,
      showSuccessDialog: false,
      isLoading: false,
      transactionProcessingMessage: TRANSACTION_PROCESSING_MESSAGE
    }
  },
  components: {
    CircleIcon: () => import('@/assets/icons/CircleIcon.vue'),
    UserPlusIcon: () => import('@/assets/v2/icons/UserPlusIcon.vue')
  },
  computed: {
    modalWidth () {
      return breakpoints.lgAndUp ? '28%' : breakpoints.mdAndUp ? '70%' : '90%'
    },
    usedBeneficiary () {
      return this.$store.state.terminal.usedBeneficiary
    },
    transactionIsFromHoldings () {
      return this.depositMethod === 'holdings'
    },
    isLocalBankTransferMethod () {
      return this.depositMethod === 'bank transfer'
    },
    initiatedTransactionAmountDetails () {
      return this.$store.state.terminal.transferInfo.transfer.depositedAmount
    }
  },
  methods: {
    doneHandler () {
      this.$emit('closeDialog')
      this.goToTransactions()
    },
    parseMoneyAll (amount, currency) {
      return ParseMoneyAll(amount, currency)
    },
    saveBeneficiary () {
      this.isLoading = true
      const vm = this
      this.$store
        .dispatch('terminal/saveBeneficiary')
        .then(() => {
          this.isLoading = false
          this.$emit('closeDialog')
          this.$emit('showSuccess')
          setTimeout(() => {
            this.$router.push('transactions')
          }, 2000)
        })
        .catch((error) => {
          this.isLoading = false
          this.$emit('closeDialog')
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.$swal({
            icon: 'error',
            title: 'Oops',
            text: err,
            iconColor: '#F26722',
            allowOutsideClick: false
          })
        })
    },
    closeSuccessDialog () {
      this.showSuccessDialog = false
    },
    showSuccess () {
      this.showSuccessDialog = true
    },
    handleClose () {
      this.$emit('closeDialog')
    },
    goToTerminal () {
      this.$store.dispatch('terminal/resetTerminalState')
      this.$router.go()
    },
    goToTransactions () {
      this.$router.push({ name: 'transactions' })
    }
  },
  destroyed () {
    this.$store.dispatch('terminal/resetTerminalState')
    this.$store.dispatch('terminal/setTransferDetails', {})
  }
}
</script>

<style scoped>
>>> .el-dialog {
  border-radius: 8px;
  padding: 0px 20px 10px 10px;
}
>>> .el-dialog__wrapper {
  overflow: hidden;
  top: 14px;
}
>>> .el-icon-close:before {
  padding: 8px;
  opacity: 0.9;
  color: #c1c4ca;
}
>>> .el-dialog__headerbtn :hover {
  color: #c1c4ca !important ;
}
@media screen and (min-width: 1280px) {
  >>> .custom-dialog-class {
    margin-left: 42vw;
  }
}
</style>
